import React from "react";

import { History } from "components";
import {
	createSplitProfileRender,
	profileHighRiskRender,
	profileNameRender,
	profilePercentRender,
	profileScenarionRender,
	profileSecondarySplitInformationRender,
	profileSecondarySplitPrivateRender,
	profileSecondarySplitScheduleARender,
	profileStatusRender,
	profileTotalRevenueShareRender,
} from "components/pages/historyTab/actionRenderers";
import { historySplitProfilesNames } from "mappers";
import { useGetSplitProfileHistoryQuery } from "queries";

type SplitProfileHistoryType = {
	splitProfileId: number;
};

const GET_SPLIT_PROFILE_HISTORY_KEY = "getSplitProfileHistory";

const SplitProfileHistory = ({ splitProfileId }: SplitProfileHistoryType) => {
	const getRendererByKey = rawKey => {
		const keyArray = rawKey?.split(".");
		const key = keyArray?.[keyArray?.length - 1];

		if (key === historySplitProfilesNames.SPLIT_PROFILE) {
			return createSplitProfileRender;
		} else if (key === historySplitProfilesNames.NAME) {
			return profileNameRender;
		} else if (key === historySplitProfilesNames.SCENARIO) {
			return profileScenarionRender;
		} else if (key === historySplitProfilesNames.IS_AVAILABLE) {
			return profileStatusRender;
		} else if (key === historySplitProfilesNames.IS_HIGH_RISK) {
			return profileHighRiskRender;
		} else if (key === historySplitProfilesNames.SPLIT_PERCENT) {
			return profilePercentRender;
		} else if (key === historySplitProfilesNames.TOTAL_REVENUE_SHARE) {
			return profileTotalRevenueShareRender;
		} else if (key === historySplitProfilesNames.SCHEDULE_A_ID) {
			return profileSecondarySplitScheduleARender;
		} else if (key === historySplitProfilesNames.IS_PRIVATE) {
			return profileSecondarySplitPrivateRender;
		} else if (
			key === historySplitProfilesNames.SECONDARY_SPLIT_INFORMATION
		)
			return profileSecondarySplitInformationRender;
	};

	return (
		<History
			id={splitProfileId}
			historyKey={GET_SPLIT_PROFILE_HISTORY_KEY}
			useHistoryListQuery={useGetSplitProfileHistoryQuery}
			getRendererByKey={getRendererByKey}
		/>
	);
};

export default SplitProfileHistory;
